import React, { FC, useState, ChangeEvent } from 'react';
import {
  TextField,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from '@mui/material';
import { Title, Check } from '@mui/icons-material';
import { EditorState } from 'draft-js';
import { EditableDraft } from 'components/EditableDraft';

import { useStyles } from './styles';

interface EditableListItemProps {
  itemText: string;
  itemIconClass: string;
  multiline?: boolean;
  content?: string | EditorState | null;
  onTextFieldChange: (value: string | EditorState) => void;
}

export const EditableListItem: FC<EditableListItemProps> = ({
  itemText,
  itemIconClass,
  content,
  multiline = false,
  onTextFieldChange,
}) => {
  const classes = useStyles();
  const [isInEditMode, setEditMode] = useState<boolean>(false);
  const isDraft = typeof content === 'object';
  return (
    <>
      {!isInEditMode && (
        <ListItem button onClick={() => setEditMode(true)}>
          <ListItemIcon className={itemIconClass}>
            <Title />
          </ListItemIcon>
          <ListItemText primary={itemText} />
        </ListItem>
      )}
      {isInEditMode && (
        <div className={classes.field}>
          {!isDraft && (
            <TextField
              fullWidth
              autoFocus
              value={content}
              multiline={multiline}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                onTextFieldChange(event.target.value)
              }
              className={classes.textField}
              rows={2}
              maxRows={2}
              variant="standard"
            />
          )}
          {isDraft && (
            <EditableDraft
              content={content}
              onDraftChange={(value: EditorState) => onTextFieldChange(value)}
            />
          )}
          <IconButton onClick={() => setEditMode(false)} size="large">
            <Check fontSize="small" />
          </IconButton>
        </div>
      )}
    </>
  );
};
